export * from './lib/transloco-root.module';
export * from './lib/transloco-custom-loader';